import {
  INPUT_MAPPING_SOURCE,
  InputMappingGroup,
} from '@/features/InputMapping/types';
import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import { formatChoice } from '@/utils/formatters/simpleChoice';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import { getLocaleDateString } from '@/utils/dates/dates';
import SalutationInfo from '@/components/modals/InputMapping/partials/sectionInfoTypes/SalutationInfo/SalutationInfo.vue';

export const versicherungsnehmerGroupMapping: InputMappingGroup = {
  icon: 'user',
  label: 'Angaben zum Versicherungsnehmer',
  infos: [
    {
      component: SalutationInfo,
      props: {
        fields: [],
      },
      requiredPaths: ['anredeId'],
      noPadding: true,
    },
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            path: 'geburtsdatum',
            formatter: getLocaleDateString,
            allowedSources: [INPUT_MAPPING_SOURCE.VERSICHERUNGSNEHMER],
          },
          {
            path: 'familienstand',
            formatter: formatChoice(SIMPLE_CHOICE.PERSONAL_STATUS),
            allowedSources: [INPUT_MAPPING_SOURCE.VERSICHERUNGSNEHMER],
          },
          {
            path: 'adresse.plz',
            allowedSources: [INPUT_MAPPING_SOURCE.VERSICHERUNGSNEHMER],
          },
          {
            path: 'nationalitaet',
            allowedSources: [INPUT_MAPPING_SOURCE.VERSICHERUNGSNEHMER],
          },
        ],
      },

      requiredPaths: [
        'geburtsdatum',
        'familienstand',
        'adresse.plz',
        'nationalitaet',
      ],
      requiredOr: true,
    },
  ],
};
